import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { addCoreDatapointConfig as baseCoreDatapointConfig } from 'owa-analytics-actions/lib/addDatapointConfig';
import type { CoreDatapointConfig } from 'owa-analytics-types';

export type CoreDatapointConfigWithoutMailbox = Omit<CoreDatapointConfig, 'mailbox'>;

export function addCoreDatapointConfig<TMessage>(
    config: CoreDatapointConfigWithoutMailbox,
    actionMessage: TMessage
): TMessage {
    const { name, ...datapointConfig } = config;

    return baseCoreDatapointConfig(name, getUserMailboxInfo(), datapointConfig, actionMessage);
}
